var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalletOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#A6A6B2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.841309 9.56006C0.841309 9.00777 1.28902 8.56006 1.84131 8.56006H22.1413C22.6936 8.56006 23.1413 9.00777 23.1413 9.56006C23.1413 10.1123 22.6936 10.5601 22.1413 10.5601H19.8335V10.8101V13.8104H22.1413C22.6936 13.8104 23.1413 14.2581 23.1413 14.8104C23.1413 15.3626 22.6936 15.8104 22.1413 15.8104H1.84131C1.28902 15.8104 0.841309 15.3626 0.841309 14.8104C0.841309 14.2581 1.28902 13.8104 1.84131 13.8104H3.77568L3.77568 10.8098V10.5601H1.84131C1.28902 10.5601 0.841309 10.1123 0.841309 9.56006ZM17.8335 13.8104V10.8101V10.5601H12.9218V10.8098V13.8104H17.8335ZM10.9218 13.8104H5.77568V10.8098V10.5601H10.9218V10.8098V13.8104Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletOutline);
export default __webpack_public_path__ + "static/media/PalletOutline.8ce05b719b97efa257ef80e3757d1fbc.svg";
export { ForwardRef as ReactComponent };